export { TrainingModule } from './src/training.module'
